export default "__VITE_ASSET__DLXAoi1j__"